import request from '../utils/request'

export function modifyProductLocation(productLocation) {
    return request({
        url: '/api/product/location/modify',
        method: 'post',
        data: productLocation
    })
}


export function deleteProductLocation(productNo) {
    return request({
        url: '/api/product/location/delete',
        method: 'delete',
        params: {
            product_no: productNo
        }
    })
}

export function exportProductLocation(keyword) {
    return request({
        url: '/api/product/location/export',
        method: 'post',
        data: {keyword},
        responseType: 'blob',
    })
}

export function scrappedProductLocations(ids, remark) {
    return request({
        url: '/api/product/location/scrapped',
        method: 'post',
        data: {ids, remark},
    })
}

export function exportProductLocationLog(keyword, dateRange) {
    return request({
        url: '/api/product/location/log/export',
        method: 'post',
        data: {keyword, dateRange},
        responseType: 'blob',
    })
}

export function modifyProductLocationArea(data) {
    return request({
        url: '/api/product/location/area/modify',
        method: 'post',
        data: data
    })
}

export function deleteProductLocationArea(areaId) {
    return request({
        url: '/api/product/location/area/',
        method: 'delete',
        params: {area_id: areaId}
    })
}

export function getProductLocationMaps(areaId) {
    return request({
        url: '/api/product/location/map/',
        method: 'get',
        params: {area_id: areaId}
    })
}

export function modifyProductLocationMap(data) {
    return request({
        url: '/api/product/location/map/modify',
        method: 'post',
        data: data
    })
}

export function exportTemporaryLocationLog(keyword, dateRange) {
    return request({
        url: '/api/temporary/location/log/export',
        method: 'post',
        data: {keyword, dateRange},
        responseType: 'blob',
    })
}
